import * as Avatar from '@radix-ui/react-avatar';

export type TenantUser = {
  id: string;
  name: string;
  email: string;
  profilePictureUrl?: string;
};

interface UserAvatarProps {
  user: TenantUser | null | undefined;
  createdBy: string | null | undefined;
  showName?: boolean;
  size?: 'sm' | 'md';
}

export function UserAvatar({
  user,
  createdBy,
  showName = true,
  size = 'sm',
}: UserAvatarProps) {
  // Determine display name based on the three cases:
  // 1. User found: show user's name (or email as fallback)
  // 2. created_by exists but user not found: show "Unknown User"
  // 3. created_by is null/undefined: show "Pliable Team"
  let displayName: string;
  let avatarUrl: string | undefined;

  if (user) {
    displayName = user.name || user.email;
    avatarUrl = user.profilePictureUrl;
  } else if (createdBy) {
    displayName = 'Unknown User';
  } else {
    displayName = 'Pliable Team';
  }

  const initials = displayName
    .split(' ')
    .map((n) => n[0])
    .join('')
    .toUpperCase()
    .slice(0, 2);

  const sizeClasses = size === 'sm' ? 'w-6 h-6 text-xs' : 'w-8 h-8 text-sm';

  return (
    <div className="flex items-center gap-2">
      <Avatar.Root
        className={`inline-flex items-center justify-center overflow-hidden select-none rounded-full bg-muted ${sizeClasses}`}
      >
        <Avatar.Image
          className="w-full h-full object-cover"
          src={avatarUrl}
          alt={displayName}
        />
        <Avatar.Fallback className="w-full h-full flex items-center justify-center bg-muted text-muted-foreground font-medium">
          {initials}
        </Avatar.Fallback>
      </Avatar.Root>
      {showName && (
        <span className="text-sm text-muted-foreground truncate max-w-[120px]">
          {displayName}
        </span>
      )}
    </div>
  );
}
